/* ============================================================
   SIZE GUIDE MODAL — IN BLOOM
   ============================================================ */

(function() {
  'use strict';

  function initSizeGuide(container) {
    if (!container || container.dataset.ibInitialized) return;
    container.dataset.ibInitialized = 'true';

    // Lectura de datos desde los <script> JSON embebidos
    var bodyDataEl = container.querySelector('[data-ib-body-data]');
    var garmentDataEl = container.querySelector('[data-ib-garment-data]');

    var bodyData = [];
    var garmentData = null;

    try {
      if (bodyDataEl) bodyData = JSON.parse(bodyDataEl.textContent);
    } catch(e) {
      console.error('[size-guide] Error parsing body_measurements JSON:', e);
    }
    try {
      if (garmentDataEl) garmentData = JSON.parse(garmentDataEl.textContent);
    } catch(e) {
      console.error('[size-guide] Error parsing garment_measurements JSON:', e);
    }

    // Estado
    var unit = 'cm';

    // Referencias DOM
    var bodyRowsEl = container.querySelector('[data-ib-body-rows]');
    var bodyCardsEl = container.querySelector('[data-ib-body-cards]');
    var garmentRowsEl = container.querySelector('[data-ib-garment-rows]');
    var garmentCardsEl = container.querySelector('[data-ib-garment-cards]');
    var garmentHeadEl = container.querySelector('[data-ib-garment-head]');
    var resultEl = container.querySelector('[data-ib-result]');
    var unitButtons = container.querySelectorAll('[data-ib-unit]');
    var inputs = {
      chest: container.querySelector('[data-ib-input="chest"]'),
      waist: container.querySelector('[data-ib-input="waist"]'),
      hip: container.querySelector('[data-ib-input="hip"]')
    };
    var prendaToggle = container.querySelector('[data-ib-prenda-toggle]');
    var prendaContent = container.querySelector('[data-ib-prenda-content]');

    // Utilidades
    function fmt(v) {
      if (v === undefined || v === null) return '—';
      return unit === 'cm' ? v : (v / 2.54).toFixed(1);
    }

    function toCm(v) {
      return unit === 'cm' ? v : v * 2.54;
    }

    // Columnas por defecto (compatibilidad con formato plano)
    var DEFAULT_GARMENT_COLUMNS = [
      { key: 'chest_width',   label: 'Ancho de Pecho' },
      { key: 'waist_width',   label: 'Ancho de Cintura' },
      { key: 'sleeve_length', label: 'Largo de Manga' },
      { key: 'bottom_length', label: 'Largo de Bottom' }
    ];

    // Acepta ambos formatos: {columns, rows} o array plano
    function normalizeGarment(data) {
      if (!data) return null;

      if (!Array.isArray(data) && data.columns && data.rows) {
        return { columns: data.columns, rows: data.rows };
      }

      if (Array.isArray(data) && data.length) {
        var cols = DEFAULT_GARMENT_COLUMNS.filter(function(c) {
          return data.some(function(r) {
            return r[c.key] !== undefined && r[c.key] !== null;
          });
        });
        return { columns: cols, rows: data };
      }

      return null;
    }

    var garmentModel = normalizeGarment(garmentData);

    function renderTables(highlightSize) {
      // ----- MEDIDAS DE CUERPO -----
      if (bodyRowsEl && bodyData.length) {
        bodyRowsEl.innerHTML = bodyData.map(function(row) {
          var isHl = row.size === highlightSize;
          return '<tr class="' + (isHl ? 'is-highlighted' : '') + '">' +
            '<td>' + row.size + (isHl ? ' ✓' : '') + '</td>' +
            '<td>' + fmt(row.chest[0]) + '–' + fmt(row.chest[1]) + '</td>' +
            '<td>' + fmt(row.waist[0]) + '–' + fmt(row.waist[1]) + '</td>' +
            '<td>' + fmt(row.hip[0]) + '–' + fmt(row.hip[1]) + '</td>' +
          '</tr>';
        }).join('');
      }

      if (bodyCardsEl && bodyData.length) {
        bodyCardsEl.innerHTML = bodyData.map(function(row) {
          var isHl = row.size === highlightSize;
          return '<div class="ib-size-guide__card ' + (isHl ? 'is-highlighted' : '') + '">' +
            '<div class="ib-size-guide__card-head">' +
              '<span class="ib-size-guide__card-title">' + row.size + '</span>' +
              (isHl ? '<span class="ib-size-guide__card-badge">✓ Tu talla</span>' : '') +
            '</div>' +
            '<div class="ib-size-guide__card-rows">' +
              '<span class="ib-size-guide__card-label">➀ Pecho</span>' +
              '<span class="ib-size-guide__card-value">' + fmt(row.chest[0]) + '–' + fmt(row.chest[1]) + ' ' + unit + '</span>' +
              '<span class="ib-size-guide__card-label">➁ Cintura</span>' +
              '<span class="ib-size-guide__card-value">' + fmt(row.waist[0]) + '–' + fmt(row.waist[1]) + ' ' + unit + '</span>' +
              '<span class="ib-size-guide__card-label">➂ Cadera</span>' +
              '<span class="ib-size-guide__card-value">' + fmt(row.hip[0]) + '–' + fmt(row.hip[1]) + ' ' + unit + '</span>' +
            '</div>' +
          '</div>';
        }).join('');
      }

      // ----- MEDIDAS DE PRENDA -----
      if (garmentModel) {
        if (garmentHeadEl) {
          garmentHeadEl.innerHTML = '<tr><th>Talla</th>' +
            garmentModel.columns.map(function(c) {
              return '<th>' + c.label + '</th>';
            }).join('') + '</tr>';
        }

        if (garmentRowsEl) {
          garmentRowsEl.innerHTML = garmentModel.rows.map(function(row) {
            return '<tr><td>' + row.size + '</td>' +
              garmentModel.columns.map(function(c) {
                return '<td>' + fmt(row[c.key]) + '</td>';
              }).join('') + '</tr>';
          }).join('');
        }

        if (garmentCardsEl) {
          garmentCardsEl.innerHTML = garmentModel.rows.map(function(row) {
            var lines = garmentModel.columns.filter(function(c) {
              return row[c.key] !== undefined && row[c.key] !== null;
            }).map(function(c) {
              return '<span class="ib-size-guide__card-label">' + c.label + '</span>' +
                     '<span class="ib-size-guide__card-value">' + fmt(row[c.key]) + ' ' + unit + '</span>';
            }).join('');

            return '<div class="ib-size-guide__card">' +
              '<div class="ib-size-guide__card-head">' +
                '<span class="ib-size-guide__card-title">' + row.size + '</span>' +
              '</div>' +
              '<div class="ib-size-guide__card-rows">' + lines + '</div>' +
            '</div>';
          }).join('');
        }
      }
    }

    // Toggle cm / in
    function setUnit(newUnit) {
      unit = newUnit;
      unitButtons.forEach(function(btn) {
        btn.classList.toggle('is-active', btn.dataset.ibUnit === unit);
      });
      recalculate();
    }

    unitButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setUnit(btn.dataset.ibUnit);
      });
    });

    // Calculadora
    function findSizeIndex(value, key) {
      if (isNaN(value)) return -1;
      var v = toCm(value);
      for (var i = 0; i < bodyData.length; i++) {
        if (v <= bodyData[i][key][1]) return i;
      }
      return bodyData.length - 1;
    }

    function recalculate() {
      var chest = inputs.chest ? parseFloat(inputs.chest.value) : NaN;
      var waist = inputs.waist ? parseFloat(inputs.waist.value) : NaN;
      var hip = inputs.hip ? parseFloat(inputs.hip.value) : NaN;

      if (isNaN(chest) && isNaN(waist) && isNaN(hip)) {
        renderTables(null);
        if (resultEl) {
          resultEl.textContent = 'Ingresa tus medidas y te sugerimos una talla.';
          resultEl.classList.remove('is-active');
        }
        return;
      }

      var best = Math.max(
        findSizeIndex(chest, 'chest'),
        findSizeIndex(waist, 'waist'),
        findSizeIndex(hip, 'hip')
      );

      if (best < 0) {
        renderTables(null);
        return;
      }

      var size = bodyData[best].size;
      renderTables(size);
      if (resultEl) {
        resultEl.innerHTML = 'Tu talla recomendada es <span class="ib-size-guide__size-badge">' + size + '</span> — fit relajado y cómodo.';
        resultEl.classList.add('is-active');
      }
    }

    Object.keys(inputs).forEach(function(key) {
      if (inputs[key]) {
        inputs[key].addEventListener('input', recalculate);
      }
    });

    // Toggle desglosable
    if (prendaToggle && prendaContent) {
      prendaToggle.addEventListener('click', function() {
        var isOpen = prendaContent.hasAttribute('hidden') === false;
        if (isOpen) {
          prendaContent.setAttribute('hidden', '');
          prendaToggle.setAttribute('aria-expanded', 'false');
        } else {
          prendaContent.removeAttribute('hidden');
          prendaToggle.setAttribute('aria-expanded', 'true');
        }
      });
    }

    // Render inicial
    renderTables(null);
  }

  function initAll() {
    document.querySelectorAll('[data-ib-size-guide]').forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();